import { render, staticRenderFns } from "./MModalCookies.vue?vue&type=template&id=88c7c3ce&"
import script from "./MModalCookies.vue?vue&type=script&lang=js&"
export * from "./MModalCookies.vue?vue&type=script&lang=js&"
import style0 from "./MModalCookies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports